import React, { Fragment, Component } from "react";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Col, Row, Form, FormGroup, Label, Input } from 'reactstrap';
import LaddaButton, {
    ZOOM_IN
} from 'react-ladda';
import axios from 'axios';
import { toast } from 'react-toastify';
import { login, saveLanguage, getLanguageHeader, setUserId, setMail, setPassword, setTemporaryToken, setAllowFilter } from '../../../Auth';
import { server_host, IsEmail, select_style, getLanguageApi } from '../../../Utils';

import PropTypes from 'prop-types';
import { translate, setDefaultLanguage } from 'react-switch-lang';

import 'dotenv';

//const PostsSlider = lazy(() => import('../News'));

class Login extends Component {
    state = {
        accessLoading: false,
        progress: 0,
        auth: [],
        mail: null,
        password: null,
        language: null,
        language_options: []
    }

    constructor(props) {
        super(props);

        this.LoginAuth = this.LoginAuth.bind(this);
    }

    LoginAuth(event) {
        event.preventDefault();

        const { mail, password } = this.state;

        const { t } = this.props;

        if (!mail || !password) {
            toast.warn(<div><b>{t('logon.incomplete_data')}</b><br /> {t('logon.complete_all_fields')}</div>);
        } else {
            if (!IsEmail(mail)) {
                toast.warn(<div><b>{t('logon.warning_toast_header')}</b><br /> {t('logon.valid_mail')}</div>);
                return false;
            }

            this.setState({
                accessLoading: true,
                progress: 0.5,
            });

            let tmpSendingLanguage = null;

            if (this.state.language.value === "pt") {
                tmpSendingLanguage = "pt-br";
            } else {
                tmpSendingLanguage = this.state.language.value;
            }

            axios.post(`${server_host}/api/token/`, {
                "email": this.state.mail,
                "password": this.state.password,
                "language": tmpSendingLanguage
            }, {
                headers: { "Accept-Language": getLanguageApi() }
            })
                .then(res => {
                    if (res.status === 200) {
                        setUserId(res.data.data.user_id);
                        setMail(this.state.mail);
                        setPassword(this.state.password);
                        setTemporaryToken(res.data.data.token);
                        setAllowFilter(res.data.data.allow_filter);

                        this.setState({
                            auth: res.data
                        });

                        setDefaultLanguage(this.state.language.value);

                        saveLanguage(this.state.language.value);

                        axios.defaults.headers.common['Accept-Language'] = getLanguageHeader();

                        if (res.data.data.customer_id !== null) {
                            // Só tem um customer, então loga direto.

                            login(this.state.auth).then(res => {
                                if (res === true) {
                                    this.setState({
                                        accessLoading: false,
                                        progress: 0,
                                    });
                                    this.props.history.push("/platform");
                                }
                                else {
                                    this.setState({
                                        accessLoading: false,
                                        progress: 0,
                                    });

                                    toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
                                }
                            });
                        } else {
                            // Tem mais de um customer, então solicita que seja selecionado

                            this.props.history.push("/auth/select-customer");
                        }
                    } else {
                        if (res.response.data.messages) {
                            res.response.data.messages.forEach(e => {
                                toast.error(<div><b>{t('logon.logon_error')}</b><br /> {e} </div>);
                            });
                        } else {
                            toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
                        }

                        this.setState({
                            accessLoading: false,
                            progress: 0,
                        });

                    }
                })
                .catch(error => {
                    this.setState({
                        accessLoading: false,
                        progress: 0,
                    });
                    toast.error(<div><b>{t('logon.logon_error')}</b><br /> {t('logon.logon_error_msg')}</div>);
                });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleLanguageChange = (language) => {
        this.setState({ language });
    }

    async componentDidMount() {
        const { t } = this.props;

        let Languages = null;

        Languages = [
            { value: "pt", label: t('logon.language_portuguese') },
            { value: "es", label: t('logon.language_spanish') },
            { value: "en", label: t('logon.language_english') }
        ];

        var userLang = navigator.language || navigator.userLanguage;

        if (userLang) {
            userLang = userLang.substring(0, 2);
        }

        let selectLanguage = null;

        selectLanguage = Languages.filter(
            function (data) { return data.value === userLang }
        )[0];

        this.setState({
            language_options: Languages,
            language: selectLanguage
        });
    }

    render() {
        const { t } = this.props;

        const language_options = this.state.language_options;
        const { language } = this.state;

        return (

            <Fragment>
                <div className="h-100">
                    <Row className="h-100 no-gutters">
                        <Col lg="12" md="12" className="h-100 d-flex bg-white justify-content-center align-items-center" >
                            <Col lg="3" md="10" sm="12" className="mx-auto app-login-box">
                                <div className="app-logo" />
                                <h4>
                                    <div>{t('logon.welcome')}</div>
                                </h4>
                                {/* <h6 className="mt-3">
                                    {t('logon.register_question')}{' '}
                                    <Link to="/auth/register" className="text-primary">{t('logon.register')}</Link>
                                </h6> */}
                                <Row className="divider" />
                                <div>
                                    <Form>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="mail">{t('logon.mail')}</Label>
                                                    <Input id="mail" value={this.state.mail || ""} type="email" onChange={e => this.handleChange(e)} name="mail" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="password">{t('logon.password')}</Label>
                                                    <Input id="password" value={this.state.password || ""} type="password" onChange={e => this.handleChange(e)} name="password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="language">{t('logon.language')}</Label>
                                                    <Select
                                                        value={language}
                                                        onChange={this.handleLanguageChange}
                                                        options={language_options}
                                                        styles={select_style}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="divider" />
                                        <div className="d-flex align-items-center">
                                            <div className="ml-auto">
                                                <Link to="/auth/forgot-password" className="btn-lg btn btn-link">{t('logon.recovery_password')}</Link>{' '}{' '}
                                                <LaddaButton className="mb-2 mr-2 btn btn-primary" onClick={this.LoginAuth} loading={this.state.accessLoading} data-style={ZOOM_IN}>{t('logon.access')}</LaddaButton>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Col>

                    </Row>
                </div>
            </Fragment>
        );
    }
}

Login.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate(Login);